import React, { useEffect, useRef, Dispatch, SetStateAction } from 'react';

interface Props {
  value?: string;
  isFocused: boolean;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  setValue: Dispatch<SetStateAction<string | undefined>>;
  isValidInput: () => boolean;
  setIsFocused: Dispatch<SetStateAction<boolean>>;
}

const CalendarCustomInput = ({ onClick, value, setValue, isValidInput, setIsFocused, isFocused }: Props) => {
  const inputRef = useRef(null);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(true);
  };

  useEffect(() => {
    setValue(value);
  }, [value]);

  return (
    <input
      readOnly
      onFocus={handleFocus}
      onBlur={handleBlur}
      name="react-datepicker-name"
      className={`example-custom-input rounded font-body font-light focus:border-[#c7c7c7] ${
        isFocused ? (isValidInput() ? 'border-[#c7c7c7]' : 'border-[#ff0000]') : 'border-[#c7c7c7]'
      }`}
      value={value}
      onClick={onClick}
      ref={inputRef}
    />
  );
};

export default CalendarCustomInput;
